export default "__VITE_ASSET__BB8STnD0__"